// extracted by mini-css-extract-plugin
export default {"component":"W0Ihv","about":"bQRQF","icon":"rbgLQ"};